import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import InsuranceInfo from './components/InsuranceInfo';
import RentConditionInfo from './components/RentConditionInfo';
import { LayoutWrapper } from './styles';

const RentInfoPage = () => {
  const [searchParams] = useSearchParams();
  const type = searchParams.get('type');
  const eng = searchParams.get('eng');
  const [queryString, setQueryString] = useState('');

  useEffect(() => {
    if (!!type) {
      setQueryString(type);
    }
  }, [type]);

  return (
    <div style={{ display: 'flex', justifyContent: 'center' }}>
      <LayoutWrapper>
        {queryString === 'insurance' || eng === 'revhelp' ? (
          <InsuranceInfo />
        ) : queryString === 'reservation' || eng === 'shuttle' ? (
          <RentConditionInfo />
        ) : null}
      </LayoutWrapper>
    </div>
  );
};

export default RentInfoPage;
